import { API_LOG_LIST } from '@/common/constants';
import { get } from '@/utils/http';

export const getLogList = (currentPage = 1, pageSize = 10, keyWord) => {
    return get(API_LOG_LIST, { currentPage, pageSize, trueName: keyWord });
};



// WEBPACK FOOTER //
// ./src/data-model/system/log-model.js